import React from "react";
import getStyled from "../../hooks/getStyled";
import PropTypes from "prop-types";

import { ListItem, ListItemButton } from "@mui/material";

import SFCheckbox from "../checkbox";

const { styled } = getStyled();

const ListItemStyled = styled(ListItem)(({ theme }) => ({
  "& .text": {
    ...theme.typography.body1,
    "&.highlighted": {
      ...theme.typography.bold,
    },
  },
}));

const ListItemButtonStyled = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== "selected",
})(({ theme, selected }) => ({
  backgroundColor: selected ? theme.palette.blue100_1.main : "transparent",
  "&:hover": {
    backgroundColor: selected
      ? theme.palette.blue100_1.main
      : theme.palette.blue50.main,
  },
  // This is to make the list item row shorter
  " .MuiCheckbox-root": {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

const GenericSearchOption = ({
  value,
  hasCheckbox,
  selected,
  onSelect,
  inputValue,
}) => {
  // Splits each option at the search input to that we can highlight
  // the part that matches that input
  
  // Escape special regex characters to prevent syntax errors
  const escapedInput = inputValue.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const parts = value.split(new RegExp("(" + escapedInput + ")", "gi"));

  return (
    <ListItemStyled key={value} disablePadding>
      <ListItemButtonStyled
        disableRipple
        selected={selected}
        onClick={onSelect}
      >
        {hasCheckbox && <SFCheckbox checked={selected} />}
        {/* Iterates through the parts and adds the class "highlighted" if the part matches the search input */}
        <div>
          {parts.map((part, idx) => (
            <span
              key={idx}
              className={`text ${
                part.toLowerCase() === inputValue.toLowerCase()
                  ? "highlighted"
                  : ""
              }`}
            >
              {part}
            </span>
          ))}
        </div>
      </ListItemButtonStyled>
    </ListItemStyled>
  );
};

GenericSearchOption.defaultProps = {
  hasCheckbox: false,
  selected: false,
  onSelect: null,
  inputValue: "",
};

GenericSearchOption.propTypes = {
  // The value that is displayed
  value: PropTypes.string.isRequired,
  // Whether each option has a checkbox
  hasCheckbox: PropTypes.bool,
  // Whether the checkbox is selected
  selected: PropTypes.bool,
  // A function that gets called when an option is clicked
  onSelect: PropTypes.func,
  // The value of the search input
  inputValue: PropTypes.string,
};

export default GenericSearchOption;
